import React, {Component} from 'react'
import PropTypes from 'prop-types'

class CommitTime extends Component {
    render() {
        const {commitmentTime} = this.props

        return (
            <td className="Procedure">
                {commitmentTime || '-'}
            </td>
        )
    }
}

CommitTime.propTypes = {
    commitment_time: PropTypes.string
}

export default CommitTime
